import moment from 'moment'

export const getMoment = (date) => {
  if (!date) {
    return '-'
  }
  return moment(date)
    .add(-5, 's')
    .fromNow()
}

export const formattedMoment = (date, format) => moment(date).format(format)

export const newMoment = (date) => moment(date)

export const getFlightConfig = (data) => {
  if(!data.SeatingConfig) {
    return 'NO SEAT MAP';
  }
  let configString = ''
  if (data.ClassFirst) {
    configString = configString + `${data.SeatConfigFirst}${data.ClassFirst}`
  }
  if (data.ClassBusiness) {
    configString =
      configString + `${data.SeatConfigBusiness}${data.ClassBusiness}`
  }
  if (data.ClassEconomy) {
    configString =
      configString + `${data.SeatConfigEconomy}${data.ClassEconomy}`
  }
  return configString
}
